import React from "react";
import { MultiSelect, Text, Box } from "@mantine/core";
import { FilterOption } from "../utils/types";

interface TypeMultiSelectProps {
  label: string;
  data: FilterOption[];
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
}

const TypeMultiSelect: React.FC<TypeMultiSelectProps> = ({
  label,
  data,
  value,
  onChange,
  placeholder = "Select a type",
}) => (
  <Box mt={24}>
    <Text size="sm" weight={400} color="dark" mb="xs">
      {label}
    </Text>
    <MultiSelect
      data={data.map((option) => ({
        value: option.value,
        label: option.display_name,
      }))}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchable
      clearable
      size="sm"
      mb="md"
    />
  </Box>
);

export default TypeMultiSelect;
